<template>
  <div class="row">
    <div class="col-md-12">
      <v-toolbar color="#5C8A9E" dark dense class="pl-5 elevation-0">
        <v-tooltip v-if="!usesBottomNav" bottom :open-delay="1000">
          <template v-slot:activator="{ on, attrs }">
            <v-app-bar-nav-icon  v-bind="attrs" v-on="on" @click="handleSidebar"></v-app-bar-nav-icon>
          </template>
          <span>Menú principal</span>
        </v-tooltip>

        <div class="position-absolute d-flex align-items-center" style="right: 5px">
          <NotificationBell />
        </div>
      </v-toolbar>
    </div>
  </div>
</template>
<script>
import NotificationBell from "@/components/NotificationBell.vue";
import { authService } from "@/libs/ws/authService";
export default {
  name: "App",
  components: { NotificationBell },
  data() {
    return {
      idiomas: [{ id: 0, name: "Lang_ES", code: "es" }],
    };
  },
  computed: {
    usesBottomNav() {
      return this.$vuetify.breakpoint.smAndDown && authService.isEmployeeUser();
    },
  },
  mounted() {
    /* this.$i18n.locale = "en"; */
  },
  methods: {
    handleSidebar() {
      if (!this.$vuetify.breakpoint.sm && !this.$vuetify.breakpoint.xs) {
        this.$store.commit("setOpenSidebar", {
          mini: !this.$store.state.sidebar.mini,
          expand_on_hover: !this.$store.state.sidebar.mini,
          open: !this.$store.state.sidebar.open,
        });
      } else {
        this.$store.commit("setOpenSidebar", {
          mini: false,
          expand_on_hover: false,
          open: !this.$store.state.sidebar.open,
        });
      }
    },
    langSelector(name) {
      this.$i18n.locale = name;
      localStorage.setItem("lang", name);
      location.reload();
    },
  },
};
</script>
